import React from 'react'
import PropTypes from 'prop-types'

import { Container, VipHeadline, Title, Deal } from './styles'

const DiscountBanner = ({ discount, deal }) => (
  <Container>
    <VipHeadline>VIP EARLY ACCESS:</VipHeadline>
    <Title>${discount} off with code MDVIP</Title>
    <Deal>
      {deal ||
        `Discount automatically applied for 10” & 15” Calendars at checkout. Ends 4/27 at 11:59pm PST or while supplies last.`}
    </Deal>
  </Container>
)

DiscountBanner.propTypes = {
  deal: PropTypes.string,
  discount: PropTypes.string,
}

export default DiscountBanner
